import { Autocomplete, FormControl, ListItemText, MenuItem, TextField } from "@mui/material";
import { useGenerateUuid } from "hooks/useGenerateUuid";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ICaixasDisponivel } from "./caixa.model";
import CaixaTransferenciaService from "./caixa-transferencia.service";

export type AutoCompleteCaixaProps = {
    caixaTitle: string,
    caixa: ICaixasDisponivel | null | undefined,
    onSetSelecionaCaixa: (caixa: ICaixasDisponivel | null) => void;
    open: boolean;
    onGetUltimoCaixa: (caixa: ICaixasDisponivel) => void
}

const initialState = {
    options: [] as Array<ICaixasDisponivel>,
    filtro: '' as string
}

const AutoCompleteCaixa = (props: AutoCompleteCaixaProps) => {
    const [randomUuid] = useGenerateUuid();
    const [stateLocal, setStateLocal] = useState(initialState)
    const transferenciaService = CaixaTransferenciaService();
    const isFirstRender = useRef<boolean>(true)

    const getOptions = useCallback(async () => {
        try {
            const { data } = await transferenciaService.getTodosCaixas();
            setStateLocal(prevState => ({
                ...prevState,
                options: data
            }))
        } catch (err) {
            return []
        }
        //eslint-disable-next-line
    }, [])

    const getUltimoCaixa = useCallback(async () => {
        try {
            const { data } = await transferenciaService.getUltimoCaixa();
            if (data) props.onGetUltimoCaixa(data)
        } catch { }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (isFirstRender.current) {
            getOptions();
            getUltimoCaixa();
        }
        isFirstRender.current = false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filterCaixasDisponiveis = useCallback((arr: ICaixasDisponivel[], filtro: string) => {
        if (!filtro) return arr
        return arr.filter(e => e.descritivo.toUpperCase().includes(filtro.toUpperCase()))
    }, [])

    const onInputChange = useCallback((e: React.SyntheticEvent, value: string) => {
        if (e && e.type === "click") {
            props.onSetSelecionaCaixa(null)
        }
        setStateLocal(prevState => ({ ...prevState, filtro: value }))
        //eslint-disable-next-line
    }, [])

    return (
        <FormControl fullWidth variant="standard" error={true} >
            <Autocomplete
                value={props.caixa}
                id="acCanalVenda"
                options={filterCaixasDisponiveis(stateLocal.options, stateLocal.filtro)}
                getOptionLabel={(option) => option.descritivo}
                onInputChange={onInputChange}
                filterOptions={(x) => x}
                noOptionsText={'Nenhum resultado encontrado'}
                isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                renderOption={(_, option) => {
                    return (
                        <MenuItem
                            key={randomUuid()}
                            value={option.descritivo}
                            onClick={() => props.onSetSelecionaCaixa(option)}
                        >
                            <ListItemText primary={option.descritivo} />
                        </MenuItem>
                    );
                }}
                renderInput={
                    (params) => <TextField {...params}
                        label={props.caixaTitle}
                        variant="standard"
                    />}
            />
        </FormControl>
    )
}

export default AutoCompleteCaixa